var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading && _vm.params.data && _vm.params.data.editable)?_c('span',[_c('button',{on:{"click":_vm.handleClick}},[_vm._v("Emitir")])]):_vm._e(),(_vm.loading && _vm.params.data.editable)?_c('span',[_vm._v("Emitiendo...")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }